import SubscriptionPackagesApi from 'api/SubscriptionPackagesApi';
import { useMutationHook, useQueryHook } from 'utility/reactQueryHooks';

const queryKeys = {
  meta: ['subscription-packages', 'meta'],
  list: (params) => ['subscription-packages', 'list', params],
};

const unwrap = (request) => request.then((response) => response.data);

const useQuerySubscriptionPackagesMeta = () =>
  useQueryHook(queryKeys.meta, () => unwrap(SubscriptionPackagesApi.getMeta()));

const useQuerySubscriptionPackages = (params) =>
  useQueryHook(queryKeys.list(params), () => unwrap(SubscriptionPackagesApi.list(params)));

const useMutationCreateSubscriptionPackage = () =>
  useMutationHook(['subscription-packages', 'create'], (data) => unwrap(SubscriptionPackagesApi.create(data)));

const useMutationRetrySubscriptionPackageSync = () =>
  useMutationHook(['subscription-packages', 'retry-sync'], (id) => unwrap(SubscriptionPackagesApi.retrySync(id)));

export {
  queryKeys,
  useMutationCreateSubscriptionPackage,
  useMutationRetrySubscriptionPackageSync,
  useQuerySubscriptionPackages,
  useQuerySubscriptionPackagesMeta,
};
